
import { Vue, Options, prop } from "vue-class-component";
import { OptionsClass } from "@/domain/entities/MainApp";
import CourierShuttleSelector from "./CourierShuttleSelector.vue";
import { CategorizedItem } from "@/app/ui/components/categorized-selector/index.vue";

class Props {
  searchValue = prop<string>({ default: "" });
  disabled = prop<boolean>({ default: true });
}

@Options({
  emits: ["search", "clearSearch", "process"],
  components: {
    CourierShuttleSelector
  }
})
export default class SearchFilter extends Vue.with(Props) {
  selectedCourierShuttle: CategorizedItem | null = null;

  onSearch(val: string) {
    this.$emit("search", val);
  }

  onClearSearch() {
    this.$emit("clearSearch");
  }

  onProcess() {
    this.$emit("process");
  }

  handleCourierShuttleChange(item: CategorizedItem) {
    this.selectedCourierShuttle = item;
    this.$emit("courierShuttleChange", item);
  }
}
